// Tekster for pipeline pakke 7 (kap. 6.8–6.9, 13.3–13.4 og 15): lagringstid,
// e-postoppsummering, nurture-listen og den månedlige gjennomgangen (M1).
export const norwegianPipelineRestMessages = {
  crm: {
    pipeline_rest: {
      retention: {
        title: "Lagringstid",
        rule_spam:
          "Leads diskvalifisert som Spam eller «Ikke en henvendelse» slettes etter 30 dager.",
        rule_other:
          "Andre diskvalifiserte leads slettes etter 12 måneder hvis kontakten ikke har annen historikk.",
        rule_raw: "Rå e-post og avviste innsendinger slettes etter 30 dager.",
        rule_deals:
          "Muligheter (åpne, vunnet og tapt) slettes aldri automatisk.",
        rule_schedule:
          "Jobben kjører hver natt kl. 03:00 og logger en anonym hendelse uten personopplysninger.",
        warning:
          "Fristene er et forslag. De må kvalitetssikres personvernmessig før lagringstid slås på.",
        switch: "Slett automatisk etter fristene over",
        preview_on: "Slettes ved neste kjøring",
        preview_off: "Ville blitt slettet nå",
        preview_error: "Kunne ikke hente forhåndsvisningen.",
        count_leads_30d: "Spam og «Ikke en henvendelse» eldre enn 30 dager",
        count_leads_12m:
          "Andre diskvalifiserte eldre enn 12 måneder uten annen historikk",
        count_raw_30d: "Rå e-post eldre enn 30 dager",
        count_rejected_30d: "Avviste innsendinger eldre enn 30 dager",
        last_run:
          "Siste kjøring %{date}%{dry}: %{leads} leads, %{contacts} kontakter, %{companies} kunder, %{raw} rå e-poster og %{rejected} avviste innsendinger slettet.",
        dry_run: " (prøvekjøring)",
        never_run: "Jobben har ikke kjørt ennå.",
        confirm_title: "Slå på lagringstid?",
        confirm_content:
          "Fra kl. 03:00 i natt slettes leads, rå e-post og avviste innsendinger etter fristene, og de kan ikke hentes tilbake. Er fristene kvalitetssikret personvernmessig?",
        confirm: "Slå på",
        turned_on: "Lagringstid er slått på. Jobben kjører kl. 03:00.",
        turned_off: "Lagringstid er slått av. Ingenting slettes automatisk.",
        save_error: "Kunne ikke lagre lagringstiden. Prøv igjen.",
      },
      digest: {
        title: "E-postoppsummering",
        switch: "Send meg «I dag» på e-post hver virkedag kl. 08:00",
        help: "E-posten sendes bare når «I dag» har noe å gjøre.",
        turned_on: "Du får «I dag» på e-post hver virkedag kl. 08:00.",
        turned_off: "E-postoppsummeringen er slått av.",
        save_error: "Kunne ikke lagre valget. Prøv igjen.",
      },
      nurture: {
        button: "Nurture-liste (%{count})",
        title: "Nurture – tidligere tapt",
        legal_note:
          "Om nurture-e-post til tidligere tapte er lov, må avklares mot markedsføringsloven og GDPR før utsending.",
        summary: "%{count} på listen, %{eligible} kan motta",
        export: "Eksporter CSV",
        empty:
          "Ingen på listen. Kontakter med samtykke kan legges her når en mulighet markeres som tapt.",
        no_name: "Uten navn",
        no_email: "Ingen e-post",
        can: "Kan motta",
        cannot: "Kan ikke motta (mangler samtykke eller er avmeldt)",
        consent: "Samtykke %{date}%{source}",
        no_consent: "Ingen registrert samtykke",
        added: "Lagt til %{date}",
        source_deal: "Muligheten",
        remove: "Fjern fra listen",
        removed: "Fjernet fra listen.",
        remove_error: "Kunne ikke fjerne kontakten. Prøv igjen.",
      },
      m1: {
        open_report: "Åpne rapporten",
      },
    },
  },
};

export const englishPipelineRestMessages = {
  crm: {
    pipeline_rest: {
      retention: {
        title: "Retention",
        rule_spam:
          "Leads disqualified as Spam or “Not an inquiry” are deleted after 30 days.",
        rule_other:
          "Other disqualified leads are deleted after 12 months if the contact has no other history.",
        rule_raw:
          "Raw email and rejected submissions are deleted after 30 days.",
        rule_deals:
          "Opportunities (open, won and lost) are never deleted automatically.",
        rule_schedule:
          "The job runs every night at 03:00 and logs an anonymous event without personal data.",
        warning:
          "The deadlines are a proposal. They must be reviewed for privacy before retention is turned on.",
        switch: "Delete automatically after the deadlines above",
        preview_on: "Deleted at the next run",
        preview_off: "Would be deleted now",
        preview_error: "Could not load the preview.",
        count_leads_30d: "Spam and “Not an inquiry” older than 30 days",
        count_leads_12m:
          "Other disqualified older than 12 months without other history",
        count_raw_30d: "Raw email older than 30 days",
        count_rejected_30d: "Rejected submissions older than 30 days",
        last_run:
          "Last run %{date}%{dry}: %{leads} leads, %{contacts} contacts, %{companies} companies, %{raw} raw emails and %{rejected} rejected submissions deleted.",
        dry_run: " (dry run)",
        never_run: "The job has not run yet.",
        confirm_title: "Turn on retention?",
        confirm_content:
          "From 03:00 tonight, leads, raw email and rejected submissions are deleted after the deadlines and cannot be recovered. Have the deadlines been reviewed for privacy?",
        confirm: "Turn on",
        turned_on: "Retention is on. The job runs at 03:00.",
        turned_off: "Retention is off. Nothing is deleted automatically.",
        save_error: "Could not save retention. Try again.",
      },
      digest: {
        title: "Email summary",
        switch: "Email me “Today” every weekday at 08:00",
        help: "The email is only sent when “Today” has something to do.",
        turned_on: "You will get “Today” by email every weekday at 08:00.",
        turned_off: "The email summary is turned off.",
        save_error: "Could not save the choice. Try again.",
      },
      nurture: {
        button: "Nurture list (%{count})",
        title: "Nurture – previously lost",
        legal_note:
          "Whether nurture email to previously lost leads is allowed must be clarified against marketing law and GDPR before sending.",
        summary: "%{count} on the list, %{eligible} can receive",
        export: "Export CSV",
        empty:
          "Nobody on the list. Contacts with consent can be added here when an opportunity is marked as lost.",
        no_name: "No name",
        no_email: "No email",
        can: "Can receive",
        cannot: "Cannot receive (missing consent or unsubscribed)",
        consent: "Consent %{date}%{source}",
        no_consent: "No recorded consent",
        added: "Added %{date}",
        source_deal: "The opportunity",
        remove: "Remove from list",
        removed: "Removed from the list.",
        remove_error: "Could not remove the contact. Try again.",
      },
      m1: {
        open_report: "Open the report",
      },
    },
  },
};
